// AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
 

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAdmin,setAdmin]=useState(false);
  const [adminId,setAdminId]=useState(null);
  const [uid,setUID]=useState('')

  

  return (
    <AuthContext.Provider value={{ adminId,setAdminId,isAuthenticated, setIsAuthenticated, loading,isAdmin,setAdmin,uid,setUID }}>
      {children}
    </AuthContext.Provider>
  );
};
